require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-natural-language-processing.json") })
        }
      }, "path---tags-natural-language-processing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-natural-language-processing!./.cache/json/tags-natural-language-processing.json
// module id = 433
// module chunks = 231608221292675